import { BITEN_ISLEMLER_LIST_GETIR, ISLEM_LIST_GETIR } from "./YoneticiBitenIslemlerAction";

export default function YoneticiBitenIslemlerReducer(
    state = {
        islemList: [],
        bitenIslemlerList: [],
        error: ""
    },
    action
) {
    switch (action.type) {
        case BITEN_ISLEMLER_LIST_GETIR:
            return {
                ...state,
                bitenIslemlerList: action.payload
            };

        case ISLEM_LIST_GETIR:
            return {
                ...state,
                islemList: action.payload
            };

        default:
            return state;
    }
}
